import axios from 'axios';
import types from './mutations-types';

const actions = {
  async getCompany({ commit }, obj) {
    const company = await axios.get(
      `${process.env.API_ROOT}/company/${obj.id}`,
      {
        headers: {
          'x-access-token': obj.token,
        },
      },
    );
    commit(types.SET_COMPANY, company.data);

    return company.data;
  },

  async uploadActionLogo({ commit }, obj) {
    const formData = new FormData();
    formData.append('file', obj.file);
    formData.append('companyId', obj.companyId);

    await axios.post(
      `${process.env.API_ROOT}/action/logo/${obj.actionId}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'x-access-token': obj.token,
        },
      },
    );
    // state.brandActions = null;
    // commit(types.SET_BRAND_ACTIONS, file.data.file);
  },

  async setWordCloud({ commit }, obj) {
    try {
      const resp = await axios.get(
        `${process.env.API_ROOT}/wordcloud/${obj.companyId}`,
        { headers: { 'x-access-token': obj.token } },
      );
      commit(types.SET_WORD_CLOUD, resp.data);
    } catch (err) {
      window.console.log(err);
    }
  },

  async setMetric({ commit }, value) {
    commit(types.SET_METRIC, value);
  },

  async addCompanyEmail(commit, obj) {
    try {
      const res = await axios.put(
        `${process.env.API_ROOT}/company/${obj.companyId}`,
        { companyEmail: obj.companyEmail },
        { headers: { 'x-access-token': obj.token } },
      );

      return res;
    } catch (err) {
      window.console.log(err);
      return err;
    }
  },
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/companies/actions.js